<template>
    <div class="create">
        <el-dialog :title="editId == 0 ? '添加' : '编辑'" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <div class="addReg">
                <div class="form" v-loading="load">
                    <el-form ref="ruleForm" :inline="true" :rules="addRules" :model="addformInline" class="demo-form-inline">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="品牌名称：" label-width="120px" prop="brandId">
                                    <el-select v-model="addformInline.brandId" placeholder="请选择品牌名称">
                                        <el-option :label="item.name" :value="item.id" v-for="(item, index) in brandNameList" :key="index"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="商品分类：" label-width="120px" prop="categoryId">
                                    <el-cascader
                                        v-model="category"
                                        @change="categoryChange"
                                        placeholder="请选择商品分类"
                                        clearable
                                        :show-all-levels="false"
                                        :options="proTreeData"
                                        :props="{ multiple: false, expandTrigger: 'hover', label: 'name', value: 'id' }"
                                    ></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="产品名称：" label-width="120px" prop="productName">
                                    <el-input v-model="addformInline.productName" placeholder="请输入产品名称" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="required">
                                <el-form-item label="类型：" label-width="120px" prop="agencyTypeLabel">
                                    <!-- <el-select v-model="addformInline.agencyType" placeholder="请选择全部分类">
                                        <el-option label="普通授权" value="1"></el-option>
                                        <el-option v-if="editId != 0" label="白名单" value="2"></el-option>
                                        <el-option v-if="editId != 0" label="黑名单" value="3"></el-option>
                                    </el-select> -->
                                    <el-input v-model="addformInline.agencyTypeLabel" disabled placeholder="请输入销售价" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="销售方式：" label-width="120px" prop="agencyType">
                                    <el-select v-model="addformInline.saleType" placeholder="请选择全部分类">
                                        <el-option label="不限" value="0"></el-option>
                                        <el-option label="线上" value="1"></el-option>
                                        <el-option label="线下" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="required" v-if="editId != 0 && addformInline.agencyType == 2">
                                <el-form-item label="销售价：" label-width="120px" prop="white_sale_price">
                                    <el-input v-model="addformInline.white_sale_price" placeholder="请输入销售价" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="required" v-else>
                                <el-form-item label="销售价：" label-width="120px" prop="sale_price">
                                    <el-input v-model="addformInline.sale_price" placeholder="请输入销售价" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="required" v-if="editId != 0 && addformInline.agencyType == 2">
                                <el-form-item label="价格上限：" label-width="120px" prop="white_price_top">
                                    <el-input v-model="addformInline.white_price_top" placeholder="请输入上限价" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="required" v-else>
                                <el-form-item label="价格上限：" label-width="120px" prop="price_top">
                                    <el-input v-model="addformInline.price_top" placeholder="请输入上限价" clearable></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12" class="required" v-if="editId != 0 && addformInline.agencyType == 2">
                                <el-form-item label="价格下限：" label-width="120px" prop="white_price_bottom">
                                    <el-input v-model="addformInline.white_price_bottom" placeholder="请输入下限价" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="required" v-else>
                                <el-form-item label="价格下限：" label-width="120px" prop="price_bottom">
                                    <el-input v-model="addformInline.price_bottom" placeholder="请输入下限价" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="URL地址：" label-width="120px" prop="url">
                                    <el-input v-model="addformInline.url" placeholder="请输入URL地址" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-for="(item, index) in delTagList" :key="index">
                                <el-form-item :label="`${item.name}：`" label-width="120px">
                                    <el-input v-model="item.value" :placeholder="`请输入${item.name}`" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="contentManage">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="添加内容" name="first">
                            <div class="tag-group">
                                <span v-if="tagList.length > 0">
                                    <el-tag type="info" @click="addTag(index, item)" v-for="(item, index) in tagList" :key="index">+ {{ item.name }}</el-tag>
                                </span>
                                <el-input
                                    style="width: 200px"
                                    class="input-new-tag"
                                    v-if="inputVisible"
                                    v-model="inputValue"
                                    ref="saveTagInput"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm"
                                    @blur="handleInputConfirm"
                                    maxlength="10"
                                    show-word-limit
                                    placeholder="请输入自定义规格名称"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 自定义</el-button>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="管理内容" name="second">
                            <div class="tag-group" v-if="delTagList.length > 0">
                                <el-tag type="info" closable @close="closeTag(index, item)" v-for="(item, index) in delTagList" :key="index">{{ item.name }}</el-tag>
                            </div>
                            <p v-else style="text-align: center; padding-top: 10px; padding-bottom: 40px">暂无标签！</p>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="medium">取 消</el-button>
                <el-button @click="submit" type="primary" size="medium" :loading="btnload">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            load: false,
            activeName: "first",
            dialogVisible: false,
            addformInline: {
                url: "",
                brandId: "", // 品牌id
                productName: "", // 产品名称
                agencyType: "1", // 普通
                agencyTypeLabel: "普通授权", // 普通
                saleType: "", // 类型 0-不限 1-线上 2-线下
                salePrice: "", // 销售价格
                priceTop: "", // 销售价格上线
                priceBottom: "", // 销售价格下线
                categoryId: "", // 产品分类Id
                specName: [], // 规格
                white_sale_price: "",
                white_price_top: "",
                white_price_bottom: "",
            },
            addRules: {
                brandId: [{ required: true, message: "请选择品牌ID", trigger: "change" }],
                productName: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
                agencyType: [{ required: true, message: "请选择类型", trigger: "change" }],
                saleType: [{ required: true, message: "请选择销售类型", trigger: "change" }],
                categoryId: [{ required: true, message: "请选择商品分类", trigger: "blur" }],
                url: [{ required: true, message: "请输入URL地址", trigger: "blur" }],
            },
            category: [],
            // tag标签
            tagList: [
                { name: "颜色", value: "" },
                { name: "大小", value: "" },
                { name: "尺寸", value: "" },
                { name: "种类", value: "" },
                { name: "型号", value: "" },
            ],
            delTagList: [],
            // 规格
            inputVisible: false,
            inputValue: "",
            btnload: false,
            editId: 0, //为0是添加，不为0是编辑
            typeList: ["普通授权", "白名单", "黑名单"],
            agencyId: 0,
        };
    },
    props: {
        brandNameList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        proTreeData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        // specList: {
        //     type: Array,
        //     default: () => {
        //         return [];
        //     },
        // },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            createProduct: "brand/createProduct", //添加产品
            editAgencyProduct: "brand/editAgencyProduct", //编辑产品
            agencyProductDetail: "brand/agencyProductDetail", //产品详情
        }),
        categoryChange(val) {
            this.addformInline.categoryId = val[val.length - 1];
        },
        getItem(arr, id) {
            let result = 0;
            arr.forEach((item) => {
                if (item.id == id) {
                    result = item.parent_id;
                } else {
                    if (item.children && item.children.length > 0) {
                        result = this.getItem(item.children, id);
                    }
                }
            });
            return result;
        },
        getDetail(id) {
            this.load = true;
            let opt = {
                token: this.getToken,
                id: this.editId,
            };
            this.agencyProductDetail(opt).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    let {
                        product_url,
                        brand_id,
                        product_name,
                        type,
                        sale_type,
                        sale_price,
                        price_top,
                        price_bottom,
                        product_category_id,
                        spec_name,
                        white_sale_price,
                        white_price_top,
                        white_price_bottom,
                    } = data.data;
                    let id_list = [];
                    let x = JSON.parse(JSON.stringify(product_category_id));
                    while (x > 0) {
                        x = this.getItem(this.proTreeData, x);
                        if (x == 0) {
                            break;
                        }
                        id_list.unshift(x);
                    }
                    id_list.push(product_category_id);
                    this.category = id_list;
                    this.addformInline = {
                        url: product_url,
                        brandId: brand_id, // 品牌id
                        productName: product_name, // 产品名称
                        agencyType: type, // 普通
                        agencyTypeLabel: this.typeList[type - 1],
                        saleType: sale_type, // 类型 0-不限 1-线上 2-线下
                        categoryId: id_list[id_list.length - 1], // 产品分类Id
                        specName: spec_name, // 规格
                        white_sale_price: white_sale_price,
                        white_price_top: white_price_top,
                        white_price_bottom: white_price_bottom,
                        sale_price: sale_price,
                        price_top: price_top,
                        price_bottom: price_bottom,
                    };
                    this.addformInline.specName.forEach((item) => {
                        this.delTagList.push(item);
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        submit() {
            // return console.log(this.addformInline.agencyType);
            switch (Number(this.addformInline.agencyType)) {
                case 1:
                    if (this.addformInline.sale_price == "") {
                        return this.$message.warning("销售价不能为空！");
                    }
                    if (!this.addformInline.price_top) {
                        return this.$message.warning("价格上限不能为空！");
                    }
                    if (!this.addformInline.price_bottom) {
                        return this.$message.warning("价格下限不能为空！");
                    }
                    break;
                case 2:
                    if (!this.addformInline.white_sale_price) {
                        return this.$message.warning("销售价不能为空！");
                    }
                    if (!this.addformInline.white_price_top) {
                        return this.$message.warning("价格上限不能为空！");
                    }
                    if (!this.addformInline.white_price_bottom) {
                        return this.$message.warning("价格下限不能为空！");
                    }
                    break;
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.btnload = true;
                    let opt = {
                        product_url: this.addformInline.url,
                        agencyProductId: this.editId == 0 ? null : this.editId,
                        token: this.getToken, // 登录token
                        brandId: this.addformInline.brandId, // 品牌id
                        productName: this.addformInline.productName, // 产品名称
                        agencyType: this.addformInline.agencyType, // 普通
                        saleType: this.addformInline.saleType, // 类型 0-不限 1-线上 2-线下
                        salePrice: this.addformInline.sale_price, // 销售价格
                        priceTop: this.addformInline.price_top, // 销售价格上线
                        priceBottom: this.addformInline.price_bottom, // 销售价格下线
                        categoryId: this.addformInline.categoryId, // 产品分类Id
                        specName: this.delTagList, // 规格
                        white_sale_price: this.addformInline.white_sale_price,
                        white_price_top: this.addformInline.white_price_top,
                        white_price_bottom: this.addformInline.white_price_bottom,
                        agencyId: this.agencyId,
                    };
                    let url;
                    if (this.editId == 0) {
                        url = this.createProduct;
                    } else {
                        url = this.editAgencyProduct;
                    }
                    url(opt).then(({ data }) => {
                        this.btnload = false;
                        if (data.code == 1) {
                            this.$message.success(`${this.editId == 0 ? "添加成功！" : "编辑成功！"}`);
                            this.$emit("init");
                            this.$emit("bindProductId", data.data.agencyProductId);
                            this.handleClose();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.btnload = false;
            this.$refs.ruleForm.resetFields();
            this.addformInline = {
                url: "",
                brandId: "", // 品牌id
                productName: "", // 产品名称
                agencyType: "1", // 普通
                agencyTypeLabel: this.typeList[0],
                saleType: "", // 类型 0-不限 1-线上 2-线下
                salePrice: "", // 销售价格
                priceTop: "", // 销售价格上线
                priceBottom: "", // 销售价格下线
                categoryId: "", // 产品分类Id
                specName: [], // 规格
            };
            this.category = [];
            this.tagList = [
                { name: "大小", value: "" },
                { name: "颜色", value: "" },
                { name: "尺寸", value: "" },
                { name: "型号", value: "" },
            ];
            this.delTagList = [];
            this.editId = 0;
            this.dialogVisible = false;
        },
        // 添加规格
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                let obj = {
                    name: inputValue,
                    value: "",
                };
                this.tagList.push(obj);
            }
            this.inputVisible = false;
            this.inputValue = "";
        },
        // 自定义
        showInput() {
            this.inputVisible = true;
            this.$nextTick((_) => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        // 规格管理
        addTag(i, v) {
            this.tagList.splice(i, 1);
            this.delTagList.push(v);
        },
        // 关闭tag标签
        closeTag(i, v) {
            if (!v.value == "") {
                return this.$message.warning("该规格有内容，无法删除！");
            }
            this.delTagList.splice(i, 1);
            this.tagList.push(v);
        },
    },
};
</script>

<style lang="scss" scoped>
.tag-group {
    padding-top: 10px;
    padding-bottom: 40px;
    .el-tag {
        margin-right: 15px;
        cursor: pointer;
        height: 34px !important;
        line-height: 34px !important;
        font-size: 14px;
        margin-bottom: 15px;
    }
    .el-button,
    .el-input {
        height: 34px;
        vertical-align: top;
    }
}
.required {
    ::v-deep .el-form-item__label {
        &::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
        }
    }
}
</style>